'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './errored.component';
import dynamic from 'next/dynamic';

const DynamicErroredComponent: ComponentType<Props> = dynamic(() => import('./errored.component'));

export default DynamicErroredComponent;

export function calculateErroredPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [{ sinceWidth: 0, height: 100 }];

  return {
    heightSinceWidth
  };
}
